import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FRAUDSTER_TOOL_KYC } from '../../../constants/fraud';
import { KYC_STATE_VALIDATED } from '../../../services/kyc/constants';

import { lockEbons } from '../../../services/ebon/actions';

import { getFraudScore, getHash } from '../../../utils/plebicardUtils';

const FunnelFraudVerificationStep = ({
    partnerId,
    userInfo,
    kycNeeded,
    setKycNeeded,
    ebon,
    lock,
    kycState,
    lockEbons
}) => {
    const [kycValidated, setKycValidated] = useState(false);

    const score = getFraudScore();
    const hash = getHash();

    const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;

    // Handle lock response
    useEffect(() => {
        if (!isEmpty(lock)) {
            // Get fraudster tools
            const suspected =
                lock[0].fraudsterProbability && lock[0].fraudsterProbability.suspected;
            const fraudsterTools = suspected && lock[0].fraudsterProbability.tools;
            const identityVerified = suspected && lock[0].fraudsterProbability.identityVerified;

            // Use appropriate fraudster tool
            if (suspected && fraudsterTools.includes(FRAUDSTER_TOOL_KYC) && !identityVerified) {
                setKycNeeded(true);
            } else {
                setKycNeeded(false);
            }
        }
    }, [lock]);

    /* Start KYC verification */
    useEffect(() => {
        if (kycState === KYC_STATE_VALIDATED) {
            setKycValidated(true);
        }
    }, [kycState]);

    useEffect(() => {
        if (kycNeeded && kycValidated) {
            doLock();
        }
    }, [kycValidated]);
    /* End KYC verification */

    // Do new lock if KYC is validated to check if the user is still suspected
    const doLock = async () => {
        const ebonCart = {
            lockRequests: ebon.cart,
            userId: userInfo.userId,
            purchaseTrackingId: userInfo.clickId,
            partnerId: partnerId,
            fixedFacialValue: !hasFreeFacial
        };

        lockEbons(
            userInfo.email,
            ebonCart,
            userInfo.userId,
            userInfo.clickId,
            score,
            hash,
            userInfo.phoneNumber
        );
    };

    return null;
};

FunnelFraudVerificationStep.propTypes = {
    partnerId: PropTypes.number,
    userInfo: PropTypes.object,
    kycNeeded: PropTypes.bool,
    setKycNeeded: PropTypes.func
};

const mapStateToProps = state => {
    return {
        ebon: state.ebon,
        lock: state.ebon.lock,
        kycState: state.kyc.state
    };
};

const mapDispatchToProps = {
    lockEbons
};

export default connect(mapStateToProps, mapDispatchToProps)(FunnelFraudVerificationStep);



// WEBPACK FOOTER //
// ./src/components/funnel/fraud-verification-step/FunnelFraudVerificationStep.js